export default function adressFullStringGetter(adresse, sansVille, avecIntitule = false) {
  if (!adresse) {
    return '';
  }
  let adresseString = '';

  if (avecIntitule) {
    const intitules = [adresse.intitule1, adresse.intitule2, adresse.intitule3]
      .filter(intitule => intitule);
    adresseString = intitules.join(' ');
    if (adresseString.length > 0) {
      adresseString += ',';
    }
  }
  if (adresse.adresse1 !== null && adresse.adresse1) {
    adresseString += ' ' + adresse.adresse1;
  }
  if (adresse.adresse2 !== null && adresse.adresse2) {
    adresseString += ' ' + adresse.adresse2;
  }
  if (adresse.adresse3 !== null && adresse.adresse3) {
    adresseString += ' ' + adresse.adresse3;
  }
  if (!sansVille) {
    if (adresseString.length > 0) {
      adresseString += ',';
    }
    if (adresse.codePostal !== null && adresse.codePostal) {
      adresseString += ' ' + adresse.codePostal;
    }
    if (adresse.ville !== null && adresse.ville) {
      adresseString += ' ' + adresse.ville;
    }
  }

  return adresseString.trim();
}
